import React from 'react';
import { useMst } from '../models/WithWineState';
import { useObserver, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { TypeProduct } from '../types/TypeProduct';
import { ProductDetailDivProps } from '../types/ProductDetailsProps';
import { ProductAward } from './ProductAward';

const UnstyledProductAwardsContainer: React.FC<ProductDetailDivProps> = (
  props,
) => {
  const stateTree = useMst();
  const productId = props.product_id || props.product?.id;

  const state = useLocalStore(() => ({
    get product() {
      if (!productId) {
        return stateTree.data.products.values().next().value as TypeProduct;
      }
      return stateTree.data.products.get(productId) as TypeProduct;
    },
    get awards() {
      if (state.product?.productAwards) {
        if (props.id) {
          const ids = Array.isArray(props.id)
            ? props.id.map((id) => id + '')
            : [props.id + ''];
          return state.product.productAwards.filter((award) =>
            ids.includes(award.id + ''),
          );
        } else {
          return state.product.productAwards;
        }
      }
      return null;
    },
  }));

  return useObserver(() => (
    <>
      {state.awards && (
        <div className="ww-product-awards section">
          {state.awards &&
            state.awards.map((a) => (
              <ProductAward data={a} key={'pa_' + a.id}></ProductAward>
            ))}
        </div>
      )}
    </>
  ));
};

const ProductAwardsContainer = styled(UnstyledProductAwardsContainer)``;

export default ProductAwardsContainer;
